import getStore from '../store/store';
import MailBoxData from '../store/schema/MailboxData';

/**
 * Selector for getting all shared folders mailbox data
 */
export default function getAllSharedFoldersData(): MailBoxData[] {
    const store = getStore();
    const allSharedFolderEmails = store.sharedFolderUserEmails;
    return allSharedFolderEmails.map(sharedFolderEmail =>
        store.mailboxTable.get(sharedFolderEmail)
    );
}
